import { Component, OnInit, Input } from '@angular/core';
import { NgModule, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-hamburger-menu',
  templateUrl: './hamburger-menu.component.html',
  styleUrls: ['./hamburger-menu.component.css']
})
export class HamburgerMenuComponent implements OnInit {
  @Input('hamburgerMenuarr') hamburgerMenu: any[]=[];
  //@Input('branch_locatorarr') branch_locator:string;
  @Input() branch_locator:string='';
  @Input() tollfree_number:string='';
  @Input() request_callback:string='';
  @Input() tollfree_num_2: string='';
  @Input() display_tollfree_2: string='';
  apiUrl= 'https://www.bajajcapital.com/'
   constructor(@Inject(DOCUMENT) private document: Document) {}
   ngOnInit(): void {
    $('.overlay').click(() =>{     
       $(this).closest('.active').removeClass('active');
       $('.children-wrapper').slideToggle(350).parent().siblings().find('.children-wrapper').slideUp(350);      
       $('.sidebar-menu').parent().find('.active').removeClass('active');
        return false;
    });
   }
   registerGASubMenu(menu:any){ 
  
   }

 }
 